import type { Product } from '~/models';

import { useNuxtApp } from '#app';

const useProductStore = defineStore('customer-product', () => {
  const { $http } = useNuxtApp();

  const list = (): Promise<Product[] | null> => {
    return $http.product.list({
      displayIn: 'ONLINE',
      categoryDisplayIn: 'ONLINE'
    });
  };

  const get = (uuid: string): Promise<Product | null> => {
    return $http.product.get(uuid);
  };

  return {
    list,
    get
  };
});

export { useProductStore };
